export class Surcharge {
  constructor(
    public key: string,
    public surchargeAmount: number|string,
    public type: string,
    public description: string,
    public mandatory: string
  ) {}
}
